module.exports = __webpack_public_path__ + "static/media/new-score.81a0c3b6.svg";